/**
 * Дата последней СОДЕРЖАТЕЛЬНОЙ правки главной — видимая строка «Обновлено»
 * и WebPage.dateModified в разметке.
 *
 * Константа, а не время сборки: weekly-rebuild.yml пересобирает сайт каждый
 * понедельник пустым коммитом, и дата от сборки прыгала бы без единой правки
 * текста — поисковик считает это накруткой свежести. Меняется руками, в том
 * же коммите, что и правка содержания (не вёрстки).
 */
export const CONTENT_UPDATED = '2026-10-21'
/**
 * Отпечаток видимого текста главной (ru + en) на дату CONTENT_UPDATED.
 * Страж tests/e2e/content-date.spec.ts сверяет его со сборкой: поменял
 * слова — обнови и дату, и отпечаток (тест напечатает новый).
 */
export const CONTENT_FINGERPRINT = '18442e9576a9'
export const CONTENT_PUBLISHED = '2026-04-15'

const MONTHS_RU = ['января', 'февраля', 'марта', 'апреля', 'мая', 'июня', 'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря']
const MONTHS_EN = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']

/** «20 сентября 2026» / «September 20, 2026» — без Intl, чтобы SSR и клиент совпали. */
export function formatContentDate(iso: string, locale: 'ru' | 'en'): string {
  const [y, m, d] = iso.split('-').map(Number)
  return locale === 'en' ? `${MONTHS_EN[m - 1]} ${d}, ${y}` : `${d} ${MONTHS_RU[m - 1]} ${y}`
}
